<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} Tour
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên tour" prop="ten_tour">
                      <el-input v-model="mData.tableRules.dataSearch.value.ten_tour" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Tên đoàn" prop="ten_doan">
                      <el-input v-model="mData.tableRules.dataSearch.value.ten_doan" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Ngày bắt đầu" prop="thoi_gian_bat_dau" :error="fn_compareTime()">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_gian_bat_dau"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Ngày kết thúc" prop="thoi_gian_ket_thuc" :error="fn_compareTime()">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_gian_ket_thuc"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button
                @click="fn_handle('create')"
                type="info"
                plain
                v-if="aRole('TourAgent')"
                :disabled="mData.dataDefault.isDisabled"
              >{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ten_tour"
            :sortable="mData.tableRules.allowSorting"
            label="Tên tour"
            min-width="200"
            width="auto"
          >
            <template slot-scope="scope">
              <!-- <el-button type="text" @click="fn_handle('detail',scope.$index, scope.row)" size="small">
                  {{scope.row.ten_tour}}
              </el-button>-->
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.ten_tour}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_doan"
            :sortable="mData.tableRules.allowSorting"
            label="Tên đoàn"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="dia_diem.dia_diem"
            :sortable="mData.tableRules.allowSorting"
            label="Địa điểm"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="so_luong_khach.so_luong"
            :sortable="mData.tableRules.allowSorting"
            label="SL khách"
            width="100"
            align="right"
          ></el-table-column>
          <el-table-column
            prop="thoi_gian_bat_dau"
            :sortable="mData.tableRules.allowSorting"
            label="TG bắt đầu"
            :formatter="fn_formatterDate"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="thoi_gian_ket_thuc"
            :sortable="mData.tableRules.allowSorting"
            label="TG kết thúc"
            :formatter="fn_formatterDate"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column prop="so_sao" label="Đánh giá" width="60" align="center">
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_goDanhGia('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.so_sao}}</el-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="da_hoan_thanh"
            :sortable="mData.tableRules.allowSorting"
            label="Hoàn thành"
            width="90"
            align="center"
            v-if="aRole('Admin,TourAgent')"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.da_hoan_thanh"
                @change="fn_changeTrangThaiHoanThanh(scope.row.id, scope.row.da_hoan_thanh)"
              ></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('duplicate',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_duplicate"
                v-if="aRole('TourAgent')"
                :disabled="mData.dataDefault.isDisabled"
              >
                <i class="icon-docs icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
                v-if="aRole('Admin,TourAgent')"
                :disabled="scope.row.da_hoan_thanh||mData.dataDefault.isDisabled"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('TourAgent')"
                :disabled="scope.row.da_hoan_thanh||mData.dataDefault.isDisabled"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import TourModel from "./TourModel";
import TourApi from "../../../moduleApi/TourApi";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "Tour", //requied
        tableRules: MethodService.copyObject(TourModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          isDisabled: false,
          listStar: [],
          validErrorTime: false
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await TourApi.list(dataFilter);
      // get Star

      let tourIds = [];
      tourIds = MethodService.findListItemDifferent(res.result, "id");
      if (tourIds.length > 0) {
        let resDanhGia = await DanhGiaApi.getStar(tourIds);
        this.mData.dataDefault.listStar = resDanhGia.result;

        for (var itemData in res.result) {
          if (
            this.mData.dataDefault.listStar.find(
              item => item.id === res.result[itemData].id
            )
          ) {
            res.result[itemData].so_sao =
              Math.round(
                this.mData.dataDefault.listStar.find(
                  item => item.id === res.result[itemData].id
                ).star
              ) + "/5";
          } else {
            res.result[itemData].so_sao = null;
          }
        }
      }
      //end getStar
      // get isDisabled
      let resLock = await CongTyLuHanhApi.list({
        filters: "id=$$cong_ty_lu_hanh_id"
      });
      if (
        resLock.result &&
        resLock.result.length > 0 &&
        resLock.result[0].isDisabled
      ) {
        this.mData.dataDefault.isDisabled = true;
      } else {
        this.mData.dataDefault.isDisabled = false;
      }
      //end get isDisabled
      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    fn_goDanhGia(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "Admin-DanhGia-list",
          query: {
            filters: "doi_tuong_danh_gia_id:in:" + row.id
          }
        });
      }
    },
    async fn_changeTrangThaiHoanThanh(id, trangThai) {
      let data = {
        id: id,
        da_hoan_thanh: trangThai
      };
      if (trangThai) {
        await TourApi.updateFinished(data);
      } else {
        if (this.aRole("Admin")) {
          await TourApi.updateFinished(data);
        } else {
          toastr.error("Tour đã hoàn thành không thể cập nhật trạng thái");
        }
      }
      this.fn_initTable();
    },
    
    //click button
    fn_handle(type, scope, row) {     
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        }).catch(()=>{});        
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });        
      }
      if (type == "duplicate") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
          query: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            var flag = true;
            if (row.huong_dan_vien_ids != undefined) {
              if (
                row.huong_dan_vien_ids != null ||
                row.huong_dan_vien_ids.length > 0
              ) {
                toastr.error(
                  "Không thể xóa tour đã có hướng dẫn viên đã xác nhận"
                );
                flag = false;
              }
            }
            if (row.khach_du_lich_ids != undefined) {
              if (
                row.khach_du_lich_ids != null ||
                row.khach_du_lich_ids.length > 0
              ) {
                toastr.error(
                  "Không thể xóa tour đã có khách du lịch đã xác nhận"
                );
                flag = false;
              }
            }

            if (row.da_hoan_thanh == true) {
              toastr.error("Không thể xóa tour đã hoàn thành");
              flag = false;
            } else {
              if (row.thoi_gian_bat_dau != undefined) {
                var _today = new Date();
                var _thoi_gian_bat_dau= new Date(row.thoi_gian_bat_dau);                
                if (_thoi_gian_bat_dau < _today) {
                  toastr.error("Không thể xóa tour do tour đã bắt đầu");
                  flag = false;
                }
              }
            }

            if (flag) {
              this.fn_delete(row.id);
            }
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await TourApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await TourApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value.ten_tour){
        this.mData.tableRules.dataSearch.value.ten_tour = this.mData.tableRules.dataSearch.value.ten_tour.trim();
      }
      if(this.mData.tableRules.dataSearch.value.ten_doan){
        this.mData.tableRules.dataSearch.value.ten_doan = this.mData.tableRules.dataSearch.value.ten_doan.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_compareTime() {
      let timeStart = this.mData.tableRules.dataSearch.value.thoi_gian_bat_dau;
      let timeEnd = this.mData.tableRules.dataSearch.value.thoi_gian_ket_thuc;

      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() > time2.getTime()) {
          this.mData.dataDefault.validErrorTime = true;
          return LanguageService.lang.valid_compareTime;
        }
      } else {
        this.mData.dataDefault.validErrorTime = false;
        return "";
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
